/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateSchema } from './candidate-schema';
import { tagSchema } from './tag-schema';

export const candidatesTagSchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  tag: z.lazy(() => tagSchema).nullish(),
  tagId: z.string().uuid().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidatesTag = z.infer<typeof candidatesTagSchema>;
